<mat-card class="income-stats" >
  <div class="custom-header">
    Income Stats

    <div class="stats-container">
      <div class="stat" (click)="changeData('todaysIncome')">
        <!-- <mat-icon>attach_money</mat-icon> -->



        <div>

          <h5><i class="material-icons"></i> ₹{{ShowIncObj['todaysIncome']}} </h5>
          <h6>Today's Income</h6>
        </div>
      </div>
      <div class="stat" (click)="changeData('weeklyincome')" >
        <!-- <mat-icon>attach_money</mat-icon> -->
        <div>
          <h5><i class="material-icons"></i> ₹{{ShowIncObj['weeklyIncome']}}</h5>
          <h6>Weekly Income</h6>
        </div>
      </div>
      <div class="stat" (click)="changeData('monthlyIncome')">
        <!-- <mat-icon>attach_money</mat-icon> -->
        <div>
          <h5><i class="material-icons"></i>₹{{ShowIncObj['monthlyIncome'] }}</h5>
          <h6>Monthly Income</h6>
        </div>
      </div>
      <div class="stat" (click)="changeData('yearlyIncome')">
        <!-- <mat-icon>attach_money</mat-icon> -->
        <div>
          <h5><i class="material-icons"></i>₹{{ShowIncObj['yearlyIncome']}} </h5>
          <h6>Yearly Income</h6>
        </div>
      </div>
      <div class="stat" (click)="changeData('totalIncome')">
        <!-- <mat-icon>attach_money</mat-icon> -->
        <div>
          <h5><i class="material-icons"></i> ₹{{ShowIncObj['totalIncome']}}</h5>
          <h6>Total Income</h6>
        </div>
      </div>
    </div>
  </div>
</mat-card>

<mat-card class="income-stats" *ngIf="tabledata">
  <br>
    <h4 style="margin-left: 2px;  font-size: 20px; font-weight: bold;" >Transaction </h4>
    <br>
    <div class="d-flex justify-content-between mb-3">
      <div class="filter d-flex">
          <i class="fa fa-search search_icon" aria-hidden="true"></i>
          <input class="input-filter" placeholder="Search by Name, Letter and Number"
              (keyup)="applyFilter($any($event.target).value)">
      </div>
  
      <div class="export_btn">
          <button class="btn_export" (click)="export()">Export</button>
      </div>
  
  </div>
  
    <div class="example-container">
      <table mat-table [dataSource]="dataSource" matSort>
  
        <ng-container matColumnDef="si_no">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>S.NO.</th>
          <td mat-cell *matCellDef="let element">{{ element.new_index }}</td>
        </ng-container>
  
        <ng-container matColumnDef="applicant_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Applicant Name</th>
          <td mat-cell *matCellDef="let element">{{ element.party_name }}</td>
        </ng-container>
  
        <ng-container matColumnDef="file_number">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>File Number</th>
          <td mat-cell *matCellDef="let element">{{ element.file_id }}</td>
        </ng-container>
  
        <ng-container matColumnDef="letter_number">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Letter Number</th>
          <td mat-cell *matCellDef="let element">{{ element.lda_letter_number }}</td>
        </ng-container>
  
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
          <td mat-cell *matCellDef="let element">{{ element.bill_date | date: 'dd/MM/yyyy' }}</td>
        </ng-container>
  
        <ng-container matColumnDef="trans_id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction ID</th>
          <td mat-cell *matCellDef="let element">{{ element.txn_id }}</td>
        </ng-container>
  
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
          <td mat-cell *matCellDef="let element"> ₹ {{ element.bill_amount }}</td>
        </ng-container>
  
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element">{{ element.status }}</td>
        </ng-container>
  
        <!-- <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
          <td mat-cell *matCellDef="let element">
            Actions can be placed here, e.g., buttons
          </td>
        </ng-container> -->
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
  
      <mat-paginator #paginator0 [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
    </div>


</mat-card>
   
